import * as i5 from '@angular/cdk/drag-drop';
import { transferArrayItem, moveItemInArray, DragDropModule, CDK_DRAG_CONFIG } from '@angular/cdk/drag-drop';
import * as i2 from '@angular/common';
import { isPlatformBrowser, DOCUMENT, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, PLATFORM_ID, numberAttribute, booleanAttribute, Component, ChangeDetectionStrategy, ViewEncapsulation, Inject, Input, Output, ViewChild, ContentChildren, NgModule } from '@angular/core';
import * as i1 from 'primeng/api';
import { PrimeTemplate, SharedModule } from 'primeng/api';
import * as i3 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import { DomHandler } from 'primeng/dom';
import { AngleDoubleDownIcon } from 'primeng/icons/angledoubledown';
import { AngleDoubleLeftIcon } from 'primeng/icons/angledoubleleft';
import { AngleDoubleRightIcon } from 'primeng/icons/angledoubleright';
import { AngleDoubleUpIcon } from 'primeng/icons/angledoubleup';
import { AngleDownIcon } from 'primeng/icons/angledown';
import { AngleLeftIcon } from 'primeng/icons/angleleft';
import { AngleRightIcon } from 'primeng/icons/angleright';
import { AngleUpIcon } from 'primeng/icons/angleup';
import { HomeIcon } from 'primeng/icons/home';
import { SearchIcon } from 'primeng/icons/search';
import * as i4 from 'primeng/ripple';
import { RippleModule } from 'primeng/ripple';
import { UniqueComponentId, ObjectUtils } from 'primeng/utils';

/**
 * PickList is used to reorder items between different lists.
 * @group Components
 */
const _c0 = ["sourcelist"];
const _c1 = ["targetlist"];
const _c2 = ["sourceFilter"];
const _c3 = ["targetFilter"];
const _c4 = a0 => ({
  "p-picklist p-component": true,
  "p-picklist-striped": a0
});
const _c5 = a0 => ({
  $implicit: a0
});
const _c6 = a0 => ({
  options: a0
});
const _c7 = (a0, a1) => ({
  $implicit: a0,
  index: a1
});
function PickList_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "button", 25);
    i0.ɵɵlistener("click", function PickList_div_1_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      const sourcelist_r4 = i0.ɵɵreference(7);
      return i0.ɵɵresetView(ctx_r2.moveUp(sourcelist_r4, ctx_r2.source, ctx_r2.selectedItemsSource, ctx_r2.onSourceReorder, ctx_r2.SOURCE_LIST));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 26);
    i0.ɵɵlistener("click", function PickList_div_1_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      const sourcelist_r4 = i0.ɵɵreference(7);
      return i0.ɵɵresetView(ctx_r2.moveTop(sourcelist_r4, ctx_r2.source, ctx_r2.selectedItemsSource, ctx_r2.onSourceReorder, ctx_r2.SOURCE_LIST));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 27);
    i0.ɵɵlistener("click", function PickList_div_1_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      const sourcelist_r4 = i0.ɵɵreference(7);
      return i0.ɵɵresetView(ctx_r2.moveDown(sourcelist_r4, ctx_r2.source, ctx_r2.selectedItemsSource, ctx_r2.onSourceReorder, ctx_r2.SOURCE_LIST));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 28);
    i0.ɵɵlistener("click", function PickList_div_1_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      const sourcelist_r4 = i0.ɵɵreference(7);
      return i0.ɵɵresetView(ctx_r2.moveBottom(sourcelist_r4, ctx_r2.source, ctx_r2.selectedItemsSource, ctx_r2.onSourceReorder, ctx_r2.SOURCE_LIST));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-pc-section", "sourceControls")("data-pc-group-section", "controls");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.sourceMoveDisabled());
    i0.ɵɵattribute("aria-label", ctx_r2.upButtonAriaLabel)("title", ctx_r2.upButtonAriaLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.sourceMoveDisabled());
    i0.ɵɵattribute("aria-label", ctx_r2.topButtonAriaLabel)("title", ctx_r2.topButtonAriaLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.sourceMoveDisabled());
    i0.ɵɵattribute("aria-label", ctx_r2.downButtonAriaLabel)("title", ctx_r2.downButtonAriaLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.sourceMoveDisabled());
    i0.ɵɵattribute("aria-label", ctx_r2.bottomButtonAriaLabel)("title", ctx_r2.bottomButtonAriaLabel);
  }
}
function PickList_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.sourceHeader);
  }
}
function PickList_div_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PickList_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtemplate(1, PickList_div_4_div_1_Template, 2, 1, "div", 30)(2, PickList_div_4_ng_container_2_Template, 1, 0, "ng-container", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r2.idSource + "_header");
    i0.ɵɵattribute("data-pc-section", "sourceHeader")("data-pc-group-section", "header");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.sourceHeaderTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.sourceHeaderTemplate);
  }
}
function PickList_div_5_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PickList_div_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PickList_div_5_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 17);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.sourceFilterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c6, ctx_r2.sourceFilterOptions));
  }
}
function PickList_div_5_ng_template_2_SearchIcon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "SearchIcon", 39);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-picklist-filter-icon");
    i0.ɵɵattribute("data-pc-section", "sourcefilterIcon");
  }
}
function PickList_div_5_ng_template_2_span_4_1_ng_template_0_Template(rf, ctx) {}
function PickList_div_5_ng_template_2_span_4_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PickList_div_5_ng_template_2_span_4_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function PickList_div_5_ng_template_2_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 40);
    i0.ɵɵtemplate(1, PickList_div_5_ng_template_2_span_4_1_Template, 1, 0, null, 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("data-pc-section", "sourcefilterIcon");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.sourceFilterIconTemplate);
  }
}
function PickList_div_5_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35)(1, "input", 36, 3);
    i0.ɵɵlistener("keyup", function PickList_div_5_ng_template_2_Template_input_keyup_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onFilter($event, ctx_r2.SOURCE_LIST));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PickList_div_5_ng_template_2_SearchIcon_3_Template, 1, 2, "SearchIcon", 37)(4, PickList_div_5_ng_template_2_span_4_Template, 2, 2, "span", 38);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "sourceFilter");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.disabled);
    i0.ɵɵattribute("placeholder", ctx_r2.sourceFilterPlaceholder)("aria-label", ctx_r2.ariaSourceFilterLabel)("data-pc-section", "sourceFilterInput");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.sourceFilterIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.sourceFilterIconTemplate);
  }
}
function PickList_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtemplate(1, PickList_div_5_ng_container_1_Template, 2, 4, "ng-container", 34)(2, PickList_div_5_ng_template_2_Template, 5, 7, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const builtInSourceElement_r6 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-pc-section", "sourceFilterContainer");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.sourceFilterTemplate)("ngIfElse", builtInSourceElement_r6);
  }
}
function PickList_ng_template_8_li_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PickList_ng_template_8_li_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 43);
    i0.ɵɵlistener("click", function PickList_ng_template_8_li_0_Template_li_click_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r7 = i0.ɵɵnextContext();
      const item_r9 = ctx_r7.$implicit;
      const i_r10 = ctx_r7.index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onItemClick($event, item_r9, ctx_r2.selectedItemsSource, ctx_r2.onSourceSelect, ctx_r2.idSource + "_" + i_r10));
    })("dblclick", function PickList_ng_template_8_li_0_Template_li_dblclick_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onSourceItemDblClick());
    })("mousedown", function PickList_ng_template_8_li_0_Template_li_mousedown_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const i_r10 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onOptionMouseDown(i_r10, ctx_r2.SOURCE_LIST));
    })("touchend", function PickList_ng_template_8_li_0_Template_li_touchend_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onItemTouchEnd());
    })("keydown", function PickList_ng_template_8_li_0_Template_li_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const item_r9 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onItemKeydown($event, item_r9, ctx_r2.selectedItemsSource, ctx_r2.onSourceSelect));
    });
    i0.ɵɵtemplate(1, PickList_ng_template_8_li_0_ng_container_1_Template, 1, 0, "ng-container", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const item_r9 = ctx_r7.$implicit;
    const i_r10 = ctx_r7.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r2.itemClass(item_r9, ctx_r2.idSource + "_" + i_r10, ctx_r2.selectedItemsSource))("id", ctx_r2.idSource + "_" + i_r10)("cdkDragData", item_r9)("cdkDragDisabled", !ctx_r2.dragdrop);
    i0.ɵɵattribute("aria-selected", ctx_r2.isSelected(item_r9, ctx_r2.selectedItemsSource));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(7, _c7, item_r9, i_r10));
  }
}
function PickList_ng_template_8_li_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PickList_ng_template_8_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 44);
    i0.ɵɵlistener("click", function PickList_ng_template_8_li_1_Template_li_click_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const item_r9 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onItemClick($event, item_r9, ctx_r2.selectedItemsSource, ctx_r2.onSourceSelect));
    })("dblclick", function PickList_ng_template_8_li_1_Template_li_dblclick_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onSourceItemDblClick());
    })("touchend", function PickList_ng_template_8_li_1_Template_li_touchend_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onItemTouchEnd());
    })("keydown", function PickList_ng_template_8_li_1_Template_li_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const item_r9 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onItemKeydown($event, item_r9, ctx_r2.selectedItemsSource, ctx_r2.onSourceSelect));
    });
    i0.ɵɵtemplate(1, PickList_ng_template_8_li_1_ng_container_1_Template, 1, 0, "ng-container", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const item_r9 = ctx_r7.$implicit;
    const i_r10 = ctx_r7.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r2.itemClass(item_r9, ctx_r2.idSource + "_" + i_r10, ctx_r2.selectedItemsSource))("id", ctx_r2.idSource + "_" + i_r10)("cdkDragData", item_r9)("cdkDragDisabled", !ctx_r2.dragdrop);
    i0.ɵɵattribute("aria-selected", ctx_r2.isSelected(item_r9, ctx_r2.selectedItemsSource));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(7, _c7, item_r9, i_r10));
  }
}
function PickList_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PickList_ng_template_8_li_0_Template, 2, 10, "li", 41)(1, PickList_ng_template_8_li_1_Template, 2, 10, "li", 42);
  }
  if (rf & 2) {
    const item_r9 = ctx.$implicit;
    const i_r10 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.isItemVisible(item_r9, ctx_r2.SOURCE_LIST) && i_r10 == 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isItemVisible(item_r9, ctx_r2.SOURCE_LIST) && i_r10 != 0);
  }
}
function PickList_ng_container_9_li_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PickList_ng_container_9_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 46);
    i0.ɵɵtemplate(1, PickList_ng_container_9_li_1_ng_container_1_Template, 1, 0, "ng-container", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "sourceEmptyMessage");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.emptyMessageSourceTemplate);
  }
}
function PickList_ng_container_9_li_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PickList_ng_container_9_li_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 46);
    i0.ɵɵtemplate(1, PickList_ng_container_9_li_2_ng_container_1_Template, 1, 0, "ng-container", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "sourceEmptyMessage");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.emptyFilterMessageSourceTemplate);
  }
}
function PickList_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PickList_ng_container_9_li_1_Template, 2, 2, "li", 45)(2, PickList_ng_container_9_li_2_Template, 2, 2, "li", 45);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.filterValueSource || !ctx_r2.emptyFilterMessageSourceTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.filterValueSource);
  }
}
function PickList_12_ng_template_0_Template(rf, ctx) {}
function PickList_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PickList_12_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function PickList_14_ng_template_0_Template(rf, ctx) {}
function PickList_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PickList_14_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function PickList_16_ng_template_0_Template(rf, ctx) {}
function PickList_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PickList_16_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function PickList_18_ng_template_0_Template(rf, ctx) {}
function PickList_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PickList_18_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function PickList_div_20_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.targetHeader);
  }
}
function PickList_div_20_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PickList_div_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtemplate(1, PickList_div_20_div_1_Template, 2, 1, "div", 30)(2, PickList_div_20_ng_container_2_Template, 1, 0, "ng-container", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r2.idTarget + "_header");
    i0.ɵɵattribute("data-pc-section", "targetHead")("data-pc-group-section", "header");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.targetHeaderTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.targetHeaderTemplate);
  }
}
function PickList_div_21_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PickList_div_21_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PickList_div_21_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 17);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.targetFilterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c6, ctx_r2.targetFilterOptions));
  }
}
function PickList_div_21_ng_template_2_SearchIcon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "SearchIcon", 39);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-picklist-filter-icon");
    i0.ɵɵattribute("data-pc-section", "targetfiltericon");
  }
}
function PickList_div_21_ng_template_2_span_4_1_ng_template_0_Template(rf, ctx) {}
function PickList_div_21_ng_template_2_span_4_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PickList_div_21_ng_template_2_span_4_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function PickList_div_21_ng_template_2_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 40);
    i0.ɵɵtemplate(1, PickList_div_21_ng_template_2_span_4_1_Template, 1, 0, null, 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("data-pc-section", "targetfiltericon");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.targetFilterIconTemplate);
  }
}
function PickList_div_21_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35)(1, "input", 36, 5);
    i0.ɵɵlistener("keyup", function PickList_div_21_ng_template_2_Template_input_keyup_1_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onFilter($event, ctx_r2.TARGET_LIST));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PickList_div_21_ng_template_2_SearchIcon_3_Template, 1, 2, "SearchIcon", 37)(4, PickList_div_21_ng_template_2_span_4_Template, 2, 2, "span", 38);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "targetFilter");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.disabled);
    i0.ɵɵattribute("placeholder", ctx_r2.targetFilterPlaceholder)("aria-label", ctx_r2.ariaTargetFilterLabel)("data-pc-section", "targetFilterInput");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.targetFilterIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.targetFilterIconTemplate);
  }
}
function PickList_div_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtemplate(1, PickList_div_21_ng_container_1_Template, 2, 4, "ng-container", 34)(2, PickList_div_21_ng_template_2_Template, 5, 7, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const builtInTargetElement_r13 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-pc-section", "targetFilterContainer");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.targetFilterTemplate)("ngIfElse", builtInTargetElement_r13);
  }
}
function PickList_ng_template_24_li_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PickList_ng_template_24_li_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 48);
    i0.ɵɵlistener("click", function PickList_ng_template_24_li_0_Template_li_click_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r14 = i0.ɵɵnextContext();
      const item_r16 = ctx_r14.$implicit;
      const i_r17 = ctx_r14.index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onItemClick($event, item_r16, ctx_r2.selectedItemsTarget, ctx_r2.onTargetSelect, ctx_r2.idTarget + "_" + i_r17));
    })("keydown", function PickList_ng_template_24_li_0_Template_li_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const item_r16 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onItemKeydown($event, item_r16, ctx_r2.selectedItemsTarget, ctx_r2.onTargetSelect));
    })("mousedown", function PickList_ng_template_24_li_0_Template_li_mousedown_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const i_r17 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onOptionMouseDown(i_r17, ctx_r2.TARGET_LIST));
    })("dblclick", function PickList_ng_template_24_li_0_Template_li_dblclick_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onTargetItemDblClick());
    })("touchend", function PickList_ng_template_24_li_0_Template_li_touchend_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onItemTouchEnd());
    });
    i0.ɵɵtemplate(1, PickList_ng_template_24_li_0_ng_container_1_Template, 1, 0, "ng-container", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    const item_r16 = ctx_r14.$implicit;
    const i_r17 = ctx_r14.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r2.itemClass(item_r16, ctx_r2.idTarget + "_" + i_r17, ctx_r2.selectedItemsTarget))("id", ctx_r2.idTarget + "_" + i_r17)("cdkDragData", item_r16)("cdkDragDisabled", !ctx_r2.dragdrop);
    i0.ɵɵattribute("aria-selected", ctx_r2.isSelected(item_r16, ctx_r2.selectedItemsTarget));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(7, _c7, item_r16, i_r17));
  }
}
function PickList_ng_template_24_li_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PickList_ng_template_24_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 44);
    i0.ɵɵlistener("click", function PickList_ng_template_24_li_1_Template_li_click_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const item_r16 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onItemClick($event, item_r16, ctx_r2.selectedItemsTarget, ctx_r2.onTargetSelect));
    })("dblclick", function PickList_ng_template_24_li_1_Template_li_dblclick_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onTargetItemDblClick());
    })("touchend", function PickList_ng_template_24_li_1_Template_li_touchend_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onItemTouchEnd());
    })("keydown", function PickList_ng_template_24_li_1_Template_li_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const item_r16 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onItemKeydown($event, item_r16, ctx_r2.selectedItemsTarget, ctx_r2.onTargetSelect));
    });
    i0.ɵɵtemplate(1, PickList_ng_template_24_li_1_ng_container_1_Template, 1, 0, "ng-container", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    const item_r16 = ctx_r14.$implicit;
    const i_r17 = ctx_r14.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r2.itemClass(item_r16, ctx_r2.idTarget + "_" + i_r17, ctx_r2.selectedItemsTarget))("id", ctx_r2.idTarget + "_" + i_r17)("cdkDragData", item_r16)("cdkDragDisabled", !ctx_r2.dragdrop);
    i0.ɵɵattribute("aria-selected", ctx_r2.isSelected(item_r16, ctx_r2.selectedItemsTarget));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(7, _c7, item_r16, i_r17));
  }
}
function PickList_ng_template_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PickList_ng_template_24_li_0_Template, 2, 10, "li", 47)(1, PickList_ng_template_24_li_1_Template, 2, 10, "li", 42);
  }
  if (rf & 2) {
    const item_r16 = ctx.$implicit;
    const i_r17 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.isItemVisible(item_r16, ctx_r2.TARGET_LIST) && i_r17 == 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isItemVisible(item_r16, ctx_r2.TARGET_LIST) && i_r17 != 0);
  }
}
function PickList_ng_container_25_li_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PickList_ng_container_25_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 46);
    i0.ɵɵtemplate(1, PickList_ng_container_25_li_1_ng_container_1_Template, 1, 0, "ng-container", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "targetEmptyMessage");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.emptyMessageTargetTemplate);
  }
}
function PickList_ng_container_25_li_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PickList_ng_container_25_li_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 46);
    i0.ɵɵtemplate(1, PickList_ng_container_25_li_2_ng_container_1_Template, 1, 0, "ng-container", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "targetEmptyMessage");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.emptyFilterMessageTargetTemplate);
  }
}
function PickList_ng_container_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PickList_ng_container_25_li_1_Template, 2, 2, "li", 45)(2, PickList_ng_container_25_li_2_Template, 2, 2, "li", 45);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.filterValueTarget || !ctx_r2.emptyFilterMessageTargetTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.filterValueTarget);
  }
}
function PickList_div_26_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 49)(1, "button", 25);
    i0.ɵɵlistener("click", function PickList_div_26_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r19);
      const ctx_r2 = i0.ɵɵnextContext();
      const targetlist_r20 = i0.ɵɵreference(23);
      return i0.ɵɵresetView(ctx_r2.moveUp(targetlist_r20, ctx_r2.target, ctx_r2.selectedItemsTarget, ctx_r2.onTargetReorder, ctx_r2.TARGET_LIST));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 26);
    i0.ɵɵlistener("click", function PickList_div_26_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r19);
      const ctx_r2 = i0.ɵɵnextContext();
      const targetlist_r20 = i0.ɵɵreference(23);
      return i0.ɵɵresetView(ctx_r2.moveTop(targetlist_r20, ctx_r2.target, ctx_r2.selectedItemsTarget, ctx_r2.onTargetReorder, ctx_r2.TARGET_LIST));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 27);
    i0.ɵɵlistener("click", function PickList_div_26_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r19);
      const ctx_r2 = i0.ɵɵnextContext();
      const targetlist_r20 = i0.ɵɵreference(23);
      return i0.ɵɵresetView(ctx_r2.moveDown(targetlist_r20, ctx_r2.target, ctx_r2.selectedItemsTarget, ctx_r2.onTargetReorder, ctx_r2.TARGET_LIST));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 28);
    i0.ɵɵlistener("click", function PickList_div_26_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r19);
      const ctx_r2 = i0.ɵɵnextContext();
      const targetlist_r20 = i0.ɵɵreference(23);
      return i0.ɵɵresetView(ctx_r2.moveBottom(targetlist_r20, ctx_r2.target, ctx_r2.selectedItemsTarget, ctx_r2.onTargetReorder, ctx_r2.TARGET_LIST));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-pc-section", "targetControls")("data-pc-group-section", "controls");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.targetMoveDisabled());
    i0.ɵɵattribute("aria-label", ctx_r2.upButtonAriaLabel)("title", ctx_r2.upButtonAriaLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.targetMoveDisabled());
    i0.ɵɵattribute("aria-label", ctx_r2.topButtonAriaLabel)("title", ctx_r2.topButtonAriaLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.targetMoveDisabled());
    i0.ɵɵattribute("aria-label", ctx_r2.downButtonAriaLabel)("title", ctx_r2.downButtonAriaLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.targetMoveDisabled());
    i0.ɵɵattribute("aria-label", ctx_r2.bottomButtonAriaLabel)("title", ctx_r2.bottomButtonAriaLabel);
  }
}
let PickList = /*#__PURE__*/(() => {
  class PickList {
    document;
    platformId;
    renderer;
    el;
    cd;
    filterService;
    config;
    zone;
    /**
     * An array of objects for the source list.
     * @group Props
     */
    source;
    /**
     * An array of objects for the target list.
     * @group Props
     */
    target;
    /**
     * Text for the source list caption
     * @group Props
     */
    sourceHeader;
    /**
     * Index of the element in tabbing order.
     * @group Props
     */
    tabindex = 0;
    /**
     * Defines a string that labels the move to right button for accessibility.
     * @group Props
     */
    rightButtonAriaLabel;
    /**
     * Defines a string that labels the move to left button for accessibility.
     * @group Props
     */
    leftButtonAriaLabel;
    /**
     * Defines a string that labels the move to all right button for accessibility.
     * @group Props
     */
    allRightButtonAriaLabel;
    /**
     * Defines a string that labels the move to all left button for accessibility.
     * @group Props
     */
    allLeftButtonAriaLabel;
    /**
     * Defines a string that labels the move to up button for accessibility.
     * @group Props
     */
    upButtonAriaLabel;
    /**
     * Defines a string that labels the move to down button for accessibility.
     * @group Props
     */
    downButtonAriaLabel;
    /**
     * Defines a string that labels the move to top button for accessibility.
     * @group Props
     */
    topButtonAriaLabel;
    /**
     * Defines a string that labels the move to bottom button for accessibility.
     * @group Props
     */
    bottomButtonAriaLabel;
    /**
     * Text for the target list caption
     * @group Props
     */
    targetHeader;
    /**
     * When enabled orderlist adjusts its controls based on screen size.
     * @group Props
     */
    responsive;
    /**
     * When specified displays an input field to filter the items on keyup and decides which field to search (Accepts multiple fields with a comma).
     * @group Props
     */
    filterBy;
    /**
     * Locale to use in filtering. The default locale is the host environment's current locale.
     * @group Props
     */
    filterLocale;
    /**
     * Function to optimize the dom operations by delegating to ngForTrackBy, default algorithm checks for object identity. Use sourceTrackBy or targetTrackBy in case different algorithms are needed per list.
     * @group Props
     */
    trackBy = (index, item) => item;
    /**
     * Function to optimize the dom operations by delegating to ngForTrackBy in source list, default algorithm checks for object identity.
     * @group Props
     */
    sourceTrackBy;
    /**
     * Function to optimize the dom operations by delegating to ngForTrackBy in target list, default algorithm checks for object identity.
     * @group Props
     */
    targetTrackBy;
    /**
     * Whether to show filter input for source list when filterBy is enabled.
     * @group Props
     */
    showSourceFilter = true;
    /**
     * Whether to show filter input for target list when filterBy is enabled.
     * @group Props
     */
    showTargetFilter = true;
    /**
     * Defines how multiple items can be selected, when true metaKey needs to be pressed to select or unselect an item and when set to false selection of each item can be toggled individually. On touch enabled devices, metaKeySelection is turned off automatically.
     * @group Props
     */
    metaKeySelection = false;
    /**
     * Whether to enable dragdrop based reordering.
     * @group Props
     */
    dragdrop = false;
    /**
     * Inline style of the component.
     * @group Props
     */
    style;
    /**
     * Style class of the component.
     * @group Props
     */
    styleClass;
    /**
     * Inline style of the source list element.
     * @group Props
     */
    sourceStyle;
    /**
     * Inline style of the target list element.
     * @group Props
     */
    targetStyle;
    /**
     * Whether to show buttons of source list.
     * @group Props
     */
    showSourceControls = true;
    /**
     * Whether to show buttons of target list.
     * @group Props
     */
    showTargetControls = true;
    /**
     * Placeholder text on source filter input.
     * @group Props
     */
    sourceFilterPlaceholder;
    /**
     * Placeholder text on target filter input.
     * @group Props
     */
    targetFilterPlaceholder;
    /**
     * When present, it specifies that the component should be disabled.
     * @group Props
     */
    disabled = false;
    /**
     * Defines a string that labels the filter input of source list.
     * @group Props
     */
    ariaSourceFilterLabel;
    /**
     * Defines a string that labels the filter input of target list.
     * @group Props
     */
    ariaTargetFilterLabel;
    /**
     * Defines how the items are filtered.
     * @group Props
     */
    filterMatchMode = 'contains';
    /**
     * Whether to displays rows with alternating colors.
     * @group Props
     */
    stripedRows;
    /**
     * Keeps selection on the transfer list.
     * @group Props
     */
    keepSelection = false;
    /**
     * Indicates the width of the screen at which the component should change its behavior.
     * @group Props
     */
    get breakpoint() {
      return this._breakpoint;
    }
    set breakpoint(value) {
      if (value !== this._breakpoint) {
        this._breakpoint = value;
        if (isPlatformBrowser(this.platformId)) {
          this.destroyMedia();
          this.initMedia();
        }
      }
    }
    selectionDescription;
    movingHint;
    /**
     * Callback to invoke when items are moved from target to source.
     * @param {PickListMoveToSourceEvent} event - Custom move to source event.
     * @group Emits
     */
    onMoveToSource = new EventEmitter();
    /**
     * Callback to invoke when all items are moved from target to source.
     * @param {PickListMoveAllToSourceEvent} event - Custom move all to source event.
     * @group Emits
     */
    onMoveAllToSource = new EventEmitter();
    /**
     * Callback to invoke when all items are moved from source to target.
     * @param {PickListMoveAllToTargetEvent} event - Custom move all to target event.
     * @group Emits
     */
    onMoveAllToTarget = new EventEmitter();
    /**
     * Callback to invoke when items are moved from source to target.
     * @param {PickListMoveToTargetEvent} event - Custom move to target event.
     * @group Emits
     */
    onMoveToTarget = new EventEmitter();
    /**
     * Callback to invoke when items are reordered within source list.
     * @param {PickListSourceReorderEvent} event - Custom source reorder event.
     * @group Emits
     */
    onSourceReorder = new EventEmitter();
    /**
     * Callback to invoke when items are reordered within target list.
     * @param {PickListTargetReorderEvent} event - Custom target reorder event.
     * @group Emits
     */
    onTargetReorder = new EventEmitter();
    /**
     * Callback to invoke when items are selected within source list.
     * @param {PickListSourceSelectEvent} event - Custom source select event.
     * @group Emits
     */
    onSourceSelect = new EventEmitter();
    /**
     * Callback to invoke when items are selected within target list.
     * @param {PickListTargetSelectEvent} event - Custom target select event.
     * @group Emits
     */
    onTargetSelect = new EventEmitter();
    /**
     * Callback to invoke when the source list is filtered
     * @param {PickListSourceFilterEvent} event - Custom source filter event.
     * @group Emits
     */
    onSourceFilter = new EventEmitter();
    /**
     * Callback to invoke when the target list is filtered
     * @param {PickListTargetFilterEvent} event - Custom target filter event.
     * @group Emits
     */
    onTargetFilter = new EventEmitter();
    /**
     * Callback to invoke when the list is focused
     * @param {Event} event - Browser event.
     * @group Emits
     */
    onFocus = new EventEmitter();
    /**
     * Callback to invoke when the list is blurred
     * @param {Event} event - Browser event.
     * @group Emits
     */
    onBlur = new EventEmitter();
    listViewSourceChild;
    listViewTargetChild;
    sourceFilterViewChild;
    targetFilterViewChild;
    templates;
    get moveUpAriaLabel() {
      return this.upButtonAriaLabel ? this.upButtonAriaLabel : this.config.translation.aria ? this.config.translation.aria.moveUp : undefined;
    }
    get moveTopAriaLabel() {
      return this.topButtonAriaLabel ? this.topButtonAriaLabel : this.config.translation.aria ? this.config.translation.aria.moveTop : undefined;
    }
    get moveDownAriaLabel() {
      return this.downButtonAriaLabel ? this.downButtonAriaLabel : this.config.translation.aria ? this.config.translation.aria.moveDown : undefined;
    }
    get moveBottomAriaLabel() {
      return this.bottomButtonAriaLabel ? this.bottomButtonAriaLabel : this.config.translation.aria ? this.config.translation.aria.moveDown : undefined;
    }
    get moveToTargetAriaLabel() {
      return this.rightButtonAriaLabel ? this.rightButtonAriaLabel : this.config.translation.aria ? this.config.translation.aria.moveToTarget : undefined;
    }
    get moveAllToTargetAriaLabel() {
      return this.allRightButtonAriaLabel ? this.allRightButtonAriaLabel : this.config.translation.aria ? this.config.translation.aria.moveAllToTarget : undefined;
    }
    get moveToSourceAriaLabel() {
      return this.leftButtonAriaLabel ? this.leftButtonAriaLabel : this.config.translation.aria ? this.config.translation.aria.moveToSource : undefined;
    }
    get moveAllToSourceAriaLabel() {
      return this.allLeftButtonAriaLabel ? this.allLeftButtonAriaLabel : this.config.translation.aria ? this.config.translation.aria.moveAllToSource : undefined;
    }
    get idSource() {
      return this.id + '_source';
    }
    get idTarget() {
      return this.id + '_target';
    }
    get focusedOptionId() {
      return this.focusedOptionIndex !== -1 ? this.focusedOptionIndex : null;
    }
    _breakpoint = '960px';
    itemTemplate;
    moveTopIconTemplate;
    moveUpIconTemplate;
    moveDownIconTemplate;
    moveBottomIconTemplate;
    moveToTargetIconTemplate;
    moveAllToTargetIconTemplate;
    moveToSourceIconTemplate;
    moveAllToSourceIconTemplate;
    targetFilterIconTemplate;
    sourceFilterIconTemplate;
    visibleOptionsSource;
    visibleOptionsTarget;
    selectedItemsSource = [];
    selectedItemsTarget = [];
    reorderedListElement;
    movedUp;
    movedDown;
    itemTouched;
    styleElement;
    id = UniqueComponentId();
    filterValueSource;
    filterValueTarget;
    fromListType;
    emptyMessageSourceTemplate;
    emptyFilterMessageSourceTemplate;
    emptyMessageTargetTemplate;
    emptyFilterMessageTargetTemplate;
    sourceHeaderTemplate;
    targetHeaderTemplate;
    sourceFilterTemplate;
    targetFilterTemplate;
    sourceFilterOptions;
    targetFilterOptions;
    SOURCE_LIST = -1;
    TARGET_LIST = 1;
    window;
    media;
    viewChanged;
    focusedOptionIndex = -1;
    focusedOption;
    focused = {
      sourceList: false,
      targetList: false
    };
    mediaChangeListener;
    constructor(document, platformId, renderer, el, cd, filterService, config, zone) {
      this.document = document;
      this.platformId = platformId;
      this.renderer = renderer;
      this.el = el;
      this.cd = cd;
      this.filterService = filterService;
      this.config = config;
      this.zone = zone;
      this.window = this.document.defaultView;
    }
    ngOnInit() {
      if (this.responsive) {
        this.createStyle();
        this.initMedia();
      }
      if (this.filterBy) {
        this.sourceFilterOptions = {
          filter: value => this.filterSource(value),
          reset: () => this.resetSourceFilter()
        };
        this.targetFilterOptions = {
          filter: value => this.filterTarget(value),
          reset: () => this.resetTargetFilter()
        };
      }
    }
    ngAfterContentInit() {
      this.templates.forEach(item => {
        switch (item.getType()) {
          case 'item':
            this.itemTemplate = item.template;
            break;
          case 'sourceHeader':
            this.sourceHeaderTemplate = item.template;
            break;
          case 'targetHeader':
            this.targetHeaderTemplate = item.template;
            break;
          case 'sourceFilter':
            this.sourceFilterTemplate = item.template;
            break;
          case 'targetFilter':
            this.targetFilterTemplate = item.template;
            break;
          case 'emptymessagesource':
            this.emptyMessageSourceTemplate = item.template;
            break;
          case 'emptyfiltermessagesource':
            this.emptyFilterMessageSourceTemplate = item.template;
            break;
          case 'emptymessagetarget':
            this.emptyMessageTargetTemplate = item.template;
            break;
          case 'emptyfiltermessagetarget':
            this.emptyFilterMessageTargetTemplate = item.template;
            break;
          case 'moveupicon':
            this.moveUpIconTemplate = item.template;
            break;
          case 'movetopicon':
            this.moveTopIconTemplate = item.template;
            break;
          case 'movedownicon':
            this.moveDownIconTemplate = item.template;
            break;
          case 'movebottomicon':
            this.moveBottomIconTemplate = item.template;
            break;
          case 'movetotargeticon':
            this.moveToTargetIconTemplate = item.template;
            break;
          case 'movealltotargeticon':
            this.moveAllToTargetIconTemplate = item.template;
            break;
          case 'movetosourceicon':
            this.moveToSourceIconTemplate = item.template;
            break;
          case 'movealltosourceicon':
            this.moveAllToSourceIconTemplate = item.template;
            break;
          case 'targetfiltericon':
            this.targetFilterIconTemplate = item.template;
            break;
          case 'sourcefiltericon':
            this.sourceFilterIconTemplate = item.template;
            break;
          default:
            this.itemTemplate = item.template;
            break;
        }
      });
    }
    ngAfterViewChecked() {
      if (this.movedUp || this.movedDown) {
        let listItems = DomHandler.find(this.reorderedListElement, 'li.p-highlight');
        let listItem;
        if (this.movedUp) listItem = listItems[0];else listItem = listItems[listItems.length - 1];
        DomHandler.scrollInView(this.reorderedListElement, listItem);
        this.movedUp = false;
        this.movedDown = false;
        this.reorderedListElement = null;
      }
    }
    onItemClick(event, item, selectedItems, callback, itemId) {
      if (this.disabled) {
        return;
      }
      let index = this.findIndexInList(item, selectedItems);
      if (itemId) this.focusedOptionIndex = itemId;
      let selected = index != -1;
      let metaSelection = this.itemTouched ? false : this.metaKeySelection;
      if (metaSelection) {
        let metaKey = event.metaKey || event.ctrlKey || event.shiftKey;
        if (selected && metaKey) {
          selectedItems.splice(index, 1);
        } else {
          if (!metaKey) {
            selectedItems.length = 0;
          }
          selectedItems.push(item);
        }
      } else {
        if (selected) selectedItems.splice(index, 1);else selectedItems.push(item);
      }
      callback.emit({
        originalEvent: event,
        items: selectedItems
      });
      this.itemTouched = false;
    }
    onOptionMouseDown(index, listType) {
      this.focused[listType === this.SOURCE_LIST ? 'sourceList' : 'targetList'] = true;
      this.focusedOptionIndex = index;
    }
    onSourceItemDblClick() {
      if (this.disabled) {
        return;
      }
      this.moveRight();
    }
    onTargetItemDblClick() {
      if (this.disabled) {
        return;
      }
      this.moveLeft();
    }
    onFilter(event, listType) {
      let query = event.target.value;
      if (listType === this.SOURCE_LIST) this.filterSource(query);else if (listType === this.TARGET_LIST) this.filterTarget(query);
    }
    filterSource(value = '') {
      this.filterValueSource = value.trim().toLocaleLowerCase(this.filterLocale);
      this.filter(this.source, this.SOURCE_LIST);
    }
    filterTarget(value = '') {
      this.filterValueTarget = value.trim().toLocaleLowerCase(this.filterLocale);
      this.filter(this.target, this.TARGET_LIST);
    }
    filter(data, listType) {
      let searchFields = this.filterBy.split(',');
      if (listType === this.SOURCE_LIST) {
        this.visibleOptionsSource = this.filterService.filter(data, searchFields, this.filterValueSource, this.filterMatchMode, this.filterLocale);
        this.onSourceFilter.emit({
          query: this.filterValueSource,
          value: this.visibleOptionsSource
        });
      } else if (listType === this.TARGET_LIST) {
        this.visibleOptionsTarget = this.filterService.filter(data, searchFields, this.filterValueTarget, this.filterMatchMode, this.filterLocale);
        this.onTargetFilter.emit({
          query: this.filterValueTarget,
          value: this.visibleOptionsTarget
        });
      }
    }
    isItemVisible(item, listType) {
      if (listType == this.SOURCE_LIST) return this.isVisibleInList(this.visibleOptionsSource, item, this.filterValueSource);else return this.isVisibleInList(this.visibleOptionsTarget, item, this.filterValueTarget);
    }
    isEmpty(listType) {
      if (listType == this.SOURCE_LIST) return this.filterValueSource ? !this.visibleOptionsSource || this.visibleOptionsSource.length === 0 : !this.source || this.source.length === 0;else return this.filterValueTarget ? !this.visibleOptionsTarget || this.visibleOptionsTarget.length === 0 : !this.target || this.target.length === 0;
    }
    isVisibleInList(data, item, filterValue) {
      if (filterValue && filterValue.trim().length) {
        for (let i = 0; i < data.length; i++) {
          if (item == data[i]) {
            return true;
          }
        }
      } else {
        return true;
      }
    }
    onItemTouchEnd() {
      if (this.disabled) {
        return;
      }
      this.itemTouched = true;
    }
    sortByIndexInList(items, list) {
      return items.sort((item1, item2) => ObjectUtils.findIndexInList(item1, list) - ObjectUtils.findIndexInList(item2, list));
    }
    moveUp(listElement, list, selectedItems, callback, listType) {
      if (selectedItems && selectedItems.length) {
        selectedItems = this.sortByIndexInList(selectedItems, list);
        for (let i = 0; i < selectedItems.length; i++) {
          let selectedItem = selectedItems[i];
          let selectedItemIndex = ObjectUtils.findIndexInList(selectedItem, list);
          if (selectedItemIndex != 0) {
            let movedItem = list[selectedItemIndex];
            let temp = list[selectedItemIndex - 1];
            list[selectedItemIndex - 1] = movedItem;
            list[selectedItemIndex] = temp;
          } else {
            break;
          }
        }
        if (this.dragdrop && (this.filterValueSource && listType === this.SOURCE_LIST || this.filterValueTarget && listType === this.TARGET_LIST)) this.filter(list, listType);
        this.movedText();
        this.movedUp = true;
        this.reorderedListElement = listElement;
        callback.emit({
          items: selectedItems
        });
      }
    }
    moveTop(listElement, list, selectedItems, callback, listType) {
      if (selectedItems && selectedItems.length) {
        selectedItems = this.sortByIndexInList(selectedItems, list);
        for (let i = 0; i < selectedItems.length; i++) {
          let selectedItem = selectedItems[i];
          let selectedItemIndex = ObjectUtils.findIndexInList(selectedItem, list);
          if (selectedItemIndex != 0) {
            let movedItem = list.splice(selectedItemIndex, 1)[0];
            list.unshift(movedItem);
          } else {
            break;
          }
        }
        if (this.dragdrop && (this.filterValueSource && listType === this.SOURCE_LIST || this.filterValueTarget && listType === this.TARGET_LIST)) this.filter(list, listType);
        this.movedText();
        listElement.scrollTop = 0;
        callback.emit({
          items: selectedItems
        });
      }
    }
    moveDown(listElement, list, selectedItems, callback, listType) {
      if (selectedItems && selectedItems.length) {
        selectedItems = this.sortByIndexInList(selectedItems, list);
        for (let i = selectedItems.length - 1; i >= 0; i--) {
          let selectedItem = selectedItems[i];
          let selectedItemIndex = ObjectUtils.findIndexInList(selectedItem, list);
          if (selectedItemIndex != list.length - 1) {
            let movedItem = list[selectedItemIndex];
            let temp = list[selectedItemIndex + 1];
            list[selectedItemIndex + 1] = movedItem;
            list[selectedItemIndex] = temp;
          } else {
            break;
          }
        }
        if (this.dragdrop && (this.filterValueSource && listType === this.SOURCE_LIST || this.filterValueTarget && listType === this.TARGET_LIST)) this.filter(list, listType);
        this.movedText();
        this.movedDown = true;
        this.reorderedListElement = listElement;
        callback.emit({
          items: selectedItems
        });
      }
    }
    moveBottom(listElement, list, selectedItems, callback, listType) {
      if (selectedItems && selectedItems.length) {
        selectedItems = this.sortByIndexInList(selectedItems, list);
        for (let i = selectedItems.length - 1; i >= 0; i--) {
          let selectedItem = selectedItems[i];
          let selectedItemIndex = ObjectUtils.findIndexInList(selectedItem, list);
          if (selectedItemIndex != list.length - 1) {
            let movedItem = list.splice(selectedItemIndex, 1)[0];
            list.push(movedItem);
          } else {
            break;
          }
        }
        if (this.dragdrop && (this.filterValueSource && listType === this.SOURCE_LIST || this.filterValueTarget && listType === this.TARGET_LIST)) this.filter(list, listType);
        this.movedText();
        listElement.scrollTop = listElement.scrollHeight;
        callback.emit({
          items: selectedItems
        });
      }
    }
    moveRight() {
      let movedItems = [];
      if (this.selectedItemsSource && this.selectedItemsSource.length) {
        for (let i = 0; i < this.selectedItemsSource.length; i++) {
          let selectedItem = this.selectedItemsSource[i];
          if (ObjectUtils.findIndexInList(selectedItem, this.target) == -1) {
            this.target?.push(this.source?.splice(ObjectUtils.findIndexInList(selectedItem, this.source), 1)[0]);
            if (this.visibleOptionsSource?.includes(selectedItem)) {
              this.visibleOptionsSource.splice(ObjectUtils.findIndexInList(selectedItem, this.visibleOptionsSource), 1);
            }
          }
          movedItems.push(selectedItem.name);
        }
        this.movedText();
        this.onMoveToTarget.emit({
          items: this.selectedItemsSource
        });
        if (this.keepSelection) {
          this.selectedItemsTarget = [...this.selectedItemsTarget, ...this.selectedItemsSource];
        }
        this.selectedItemsSource = [];
        if (this.filterValueTarget) {
          this.filter(this.target, this.TARGET_LIST);
        }
      }
      this.focus();
    }
    moveAllRight() {
      if (this.source) {
        let movedItems = [];
        for (let i = 0; i < this.source.length; i++) {
          if (this.isItemVisible(this.source[i], this.SOURCE_LIST)) {
            let removedItem = this.source.splice(i, 1)[0];
            this.target?.push(removedItem);
            movedItems.push(removedItem);
            i--;
          }
        }
        this.movedText();
        this.onMoveAllToTarget.emit({
          items: movedItems
        });
        if (this.keepSelection) {
          this.selectedItemsTarget = [...this.selectedItemsTarget, ...this.selectedItemsSource];
        }
        this.selectedItemsSource = [];
        if (this.filterValueTarget) {
          this.filter(this.target, this.TARGET_LIST);
        }
        this.visibleOptionsSource = [];
      }
      this.focus();
    }
    moveLeft() {
      let movedItems = [];
      if (this.selectedItemsTarget && this.selectedItemsTarget.length) {
        for (let i = 0; i < this.selectedItemsTarget.length; i++) {
          let selectedItem = this.selectedItemsTarget[i];
          if (ObjectUtils.findIndexInList(selectedItem, this.source) == -1) {
            this.source?.push(this.target?.splice(ObjectUtils.findIndexInList(selectedItem, this.target), 1)[0]);
            if (this.visibleOptionsTarget?.includes(selectedItem)) {
              this.visibleOptionsTarget.splice(ObjectUtils.findIndexInList(selectedItem, this.visibleOptionsTarget), 1)[0];
            }
          }
          movedItems.push(selectedItem.name);
        }
        this.movedText();
        this.onMoveToSource.emit({
          items: this.selectedItemsTarget
        });
        if (this.keepSelection) {
          this.selectedItemsSource = [...this.selectedItemsSource, ...this.selectedItemsTarget];
        }
        this.selectedItemsTarget = [];
        if (this.filterValueSource) {
          this.filter(this.source, this.SOURCE_LIST);
        }
      }
      this.focus();
    }
    moveAllLeft() {
      if (this.target) {
        let movedItems = [];
        for (let i = 0; i < this.target.length; i++) {
          if (this.isItemVisible(this.target[i], this.TARGET_LIST)) {
            let removedItem = this.target.splice(i, 1)[0];
            this.source?.push(removedItem);
            movedItems.push(removedItem);
            i--;
          }
        }
        this.movedText();
        this.onMoveAllToSource.emit({
          items: movedItems
        });
        if (this.keepSelection) {
          this.selectedItemsSource = [...this.selectedItemsSource, ...this.selectedItemsTarget];
        }
        this.selectedItemsTarget = [];
        if (this.filterValueSource) {
          this.filter(this.source, this.SOURCE_LIST);
        }
        this.visibleOptionsTarget = [];
      }
      this.focus();
    }
    // HIS-PATCH Fokusreihenfolge auf nächstes Element, bzw. sonst erstes Listenelement
    focus() {
      let focusable = DomHandler.find(this.el.nativeElement, '[autofocus]');
      let index = focusable.indexOf(document.activeElement);
      if (focusable) {
        this.zone.runOutsideAngular(() => {
          setTimeout(() => {
            if (index > -1) {
              for (let i = 0; i < focusable.length - index; i++) {
                let nextElement = focusable[index + i];
                if (!nextElement.disabled) {
                  nextElement.focus();
                  break;
                } else {
                  let sourceListFirstLi = document.querySelectorAll('.p-picklist-source > li')[0];
                  if (focusable[index + i + 1]) {
                    focusable[index + i + 1].focus();
                  } else {
                    sourceListFirstLi.focus();
                  }
                }
              }
            }
          }, 5);
        });
      }
    }
    //HIS-Patch: Methode ergänzt das div-Element mit aria-live um den Erfolgsheinweis für das Verschieben
    movedText() {
      let hintText = document.getElementById('movingHint');
      hintText.innerHTML = this.movingHint;
      setTimeout(() => {
        hintText.innerHTML = '';
      }, 500);
    }
    isSelected(item, selectedItems) {
      return this.findIndexInList(item, selectedItems) != -1;
    }
    itemClass(item, id, selectedItems) {
      return {
        'p-picklist-item': true,
        'p-highlight': this.isSelected(item, selectedItems),
        'p-focus': id === this.focusedOptionId,
        'p-disabled': this.disabled
      };
    }
    findIndexInList(item, selectedItems) {
      return ObjectUtils.findIndexInList(item, selectedItems);
    }
    onDrop(event, listType) {
      let isTransfer = event.previousContainer !== event.container;
      let dropIndexes = this.getDropIndexes(event.previousIndex, event.currentIndex, listType, isTransfer, event.item.data);
      if (listType === this.SOURCE_LIST) {
        if (isTransfer) {
          transferArrayItem(event.previousContainer.data, event.container.data, dropIndexes.previousIndex, dropIndexes.currentIndex);
          let selectedItemIndex = ObjectUtils.findIndexInList(event.item.data, this.selectedItemsTarget);
          if (selectedItemIndex != -1) {
            this.selectedItemsTarget.splice(selectedItemIndex, 1);
            if (this.keepSelection) {
              this.selectedItemsTarget.push(event.item.data);
            }
          }
          if (this.visibleOptionsTarget) this.visibleOptionsTarget.splice(event.previousIndex, 1);
          this.onMoveToSource.emit({
            items: [event.item.data]
          });
        } else {
          moveItemInArray(event.container.data, dropIndexes.previousIndex, dropIndexes.currentIndex);
          this.onSourceReorder.emit({
            items: [event.item.data]
          });
        }
        if (this.filterValueSource) {
          this.filter(this.source, this.SOURCE_LIST);
        }
      } else {
        if (isTransfer) {
          transferArrayItem(event.previousContainer.data, event.container.data, dropIndexes.previousIndex, dropIndexes.currentIndex);
          let selectedItemIndex = ObjectUtils.findIndexInList(event.item.data, this.selectedItemsSource);
          if (selectedItemIndex != -1) {
            this.selectedItemsSource.splice(selectedItemIndex, 1);
            if (this.keepSelection) {
              this.selectedItemsTarget.push(event.item.data);
            }
          }
          if (this.visibleOptionsSource) this.visibleOptionsSource.splice(event.previousIndex, 1);
          this.onMoveToTarget.emit({
            items: [event.item.data]
          });
        } else {
          moveItemInArray(event.container.data, dropIndexes.previousIndex, dropIndexes.currentIndex);
          this.onTargetReorder.emit({
            items: [event.item.data]
          });
        }
        if (this.filterValueTarget) {
          this.filter(this.target, this.TARGET_LIST);
        }
      }
    }
    onListFocus(event, listType) {
      let listElement = this.getListElement(listType);
      const selectedFirstItem = DomHandler.findSingle(listElement, 'li.p-picklist-item.p-highlight') || DomHandler.findSingle(listElement, 'li.p-picklist-item');
      const findIndex = ObjectUtils.findIndexInList(selectedFirstItem, listElement.children);
      this.focused[listType === this.SOURCE_LIST ? 'sourceList' : 'targetList'] = true;
      const sourceIndex = this.focusedOptionIndex !== -1 ? this.focusedOptionIndex : selectedFirstItem ? findIndex : -1;
      const filteredIndex = ObjectUtils.isNotEmpty(this.visibleOptionsSource) ? this.findIndexInList(this.source[sourceIndex], this.visibleOptionsSource) : sourceIndex;
      this.changeFocusedOptionIndex(filteredIndex, listType);
      this.onFocus.emit(event);
    }
    onListBlur(event, listType) {
      this.focused[listType === this.SOURCE_LIST ? 'sourceList' : 'targetList'] = false;
      this.focusedOptionIndex = -1;
      this.focusedOption = null;
      this.onBlur.emit(event);
    }
    getListElement(listType) {
      return listType === this.SOURCE_LIST ? this.listViewSourceChild?.nativeElement : this.listViewTargetChild?.nativeElement;
    }
    getListItems(listType) {
      let listElemet = this.getListElement(listType);
      return DomHandler.find(listElemet, 'li.p-picklist-item');
    }
    getLatestSelectedVisibleOptionIndex(visibleList, selectedItems) {
      const latestSelectedItem = [...selectedItems].reverse().find(item => visibleList.includes(item));
      return latestSelectedItem !== undefined ? visibleList.indexOf(latestSelectedItem) : -1;
    }
    getVisibleList(listType) {
      if (listType === this.SOURCE_LIST) {
        return this.visibleOptionsSource && this.visibleOptionsSource.length > 0 ? this.visibleOptionsSource : this.source && this.source.length > 0 ? this.source : null;
      }
      return this.visibleOptionsTarget && this.visibleOptionsTarget.length > 0 ? this.visibleOptionsTarget : this.target && this.target.length > 0 ? this.target : null;
    }
    setSelectionList(listType, selectedItems) {
      if (listType === this.SOURCE_LIST) {
        this.selectedItemsSource = selectedItems;
      } else {
        this.selectedItemsTarget = selectedItems;
      }
    }
    findNextOptionIndex(index, listType) {
      const items = this.getListItems(listType);
      const matchedOptionIndex = [...items].findIndex(link => link.id === index);
      return matchedOptionIndex > -1 ? matchedOptionIndex + 1 : 0;
    }
    findPrevOptionIndex(index, listType) {
      const items = this.getListItems(listType);
      const matchedOptionIndex = [...items].findIndex(link => link.id === index);
      return matchedOptionIndex > -1 ? matchedOptionIndex - 1 : 0;
    }
    onItemKeydown(event, item, selectedItems, callback) {
      let listItem = event.currentTarget;
      switch (event.which) {
        //down
        case 40:
          var nextItem = this.findNextItem(listItem);
          if (nextItem) {
            nextItem.focus();
          }
          event.preventDefault();
          break;
        //up
        case 38:
          var prevItem = this.findPrevItem(listItem);
          if (prevItem) {
            prevItem.focus();
          }
          event.preventDefault();
          break;
        //enter
        case 13:
          this.onItemClick(event, item, selectedItems, callback);
          event.preventDefault();
          break;
      }
    }
    getFocusedOption(index, listType) {
      if (index === -1) return null;
      if (listType === this.SOURCE_LIST) {
        return this.visibleOptionsSource && this.visibleOptionsSource.length ? this.visibleOptionsSource[index] : this.source && this.source.length ? this.source[index] : null;
      }
      return this.visibleOptionsTarget && this.visibleOptionsTarget.length ? this.visibleOptionsTarget[index] : this.target && this.target.length ? this.target[index] : null;
    }
    changeFocusedOptionIndex(index, listType) {
      const items = this.getListItems(listType);
      if (items?.length > 0) {
        let order = index >= items.length ? items.length - 1 : index < 0 ? 0 : index;
        this.focusedOptionIndex = items[order].getAttribute('id');
        this.focusedOption = this.getFocusedOption(order, listType);
        this.scrollInView(items[order].getAttribute('id'), listType);
      }
    }
    scrollInView(id, listType) {
      const element = DomHandler.findSingle(this.getListElement(listType), `li[id="${id}"]`);
      if (element) {
        element.scrollIntoView && element.scrollIntoView({
          block: 'nearest',
          inline: 'start'
        });
      }
    }
    onArrowDownKey(event, selectedItems, callback, listType) {
      const optionIndex = this.findNextOptionIndex(this.focusedOptionIndex, listType);
      this.changeFocusedOptionIndex(optionIndex, listType);
      if (event.shiftKey) {
        this.onEnterKey(event, selectedItems, callback, listType);
      }
      event.preventDefault();
    }
    onArrowUpKey(event, selectedItems, callback, listType) {
      const optionIndex = this.findPrevOptionIndex(this.focusedOptionIndex, listType);
      this.changeFocusedOptionIndex(optionIndex, listType);
      if (event.shiftKey) {
        this.onEnterKey(event, selectedItems, callback, listType);
      }
      event.preventDefault();
    }
    onEnterKey(event, selectedItems, callback, listType) {
      this.onItemClick(event, this.focusedOption, selectedItems, callback);
      event.preventDefault();
    }
    onSpaceKey(event, selectedItems, callback, listType) {
      event.preventDefault();
      if (event.shiftKey && selectedItems && selectedItems.length > 0) {
        let visibleList = this.getVisibleList(listType);
        let lastSelectedIndex = this.getLatestSelectedVisibleOptionIndex(visibleList, selectedItems);
        if (lastSelectedIndex !== -1) {
          let focusedIndex = ObjectUtils.findIndexInList(this.focusedOption, visibleList);
          selectedItems = [...visibleList.slice(Math.min(lastSelectedIndex, focusedIndex), Math.max(lastSelectedIndex, focusedIndex) + 1)];
          this.setSelectionList(listType, selectedItems);
          callback.emit({
            items: selectedItems
          });
          return;
        }
      }
      this.onEnterKey(event, selectedItems, callback, listType);
    }
    onHomeKey(event, selectedItems, callback, listType) {
      if (event.ctrlKey && event.shiftKey) {
        let visibleList = this.getVisibleList(listType);
        let focusedIndex = ObjectUtils.findIndexInList(this.focusedOption, visibleList);
        selectedItems = [...visibleList.slice(0, focusedIndex + 1)];
        this.setSelectionList(listType, selectedItems);
        callback.emit({
          items: selectedItems
        });
      } else {
        this.changeFocusedOptionIndex(0, listType);
      }
      event.preventDefault();
    }
    onEndKey(event, selectedItems, callback, listType) {
      let visibleList = this.getVisibleList(listType);
      let lastIndex = visibleList && visibleList.length > 0 ? visibleList.length - 1 : null;
      if (lastIndex === null) return;
      if (event.ctrlKey && event.shiftKey) {
        let focusedIndex = ObjectUtils.findIndexInList(this.focusedOption, visibleList);
        selectedItems = [...visibleList.slice(focusedIndex, lastIndex)];
        this.setSelectionList(listType, selectedItems);
        callback.emit({
          items: selectedItems
        });
      } else {
        this.changeFocusedOptionIndex(lastIndex, listType);
      }
      event.preventDefault();
    }
    getDropIndexes(fromIndex, toIndex, droppedList, isTransfer, data) {
      let previousIndex, currentIndex;
      if (droppedList === this.SOURCE_LIST) {
        previousIndex = isTransfer ? this.filterValueTarget ? ObjectUtils.findIndexInList(data, this.target) : fromIndex : this.filterValueSource ? ObjectUtils.findIndexInList(data, this.source) : fromIndex;
        currentIndex = this.filterValueSource ? this.findFilteredCurrentIndex(this.visibleOptionsSource, toIndex, this.source) : toIndex;
      } else {
        previousIndex = isTransfer ? this.filterValueSource ? ObjectUtils.findIndexInList(data, this.source) : fromIndex : this.filterValueTarget ? ObjectUtils.findIndexInList(data, this.target) : fromIndex;
        currentIndex = this.filterValueTarget ? this.findFilteredCurrentIndex(this.visibleOptionsTarget, toIndex, this.target) : toIndex;
      }
      return {
        previousIndex,
        currentIndex
      };
    }
    findFilteredCurrentIndex(visibleOptions, index, options) {
      if (visibleOptions.length === index) {
        let toIndex = ObjectUtils.findIndexInList(visibleOptions[index - 1], options);
        return toIndex + 1;
      } else {
        return ObjectUtils.findIndexInList(visibleOptions[index], options);
      }
    }
    resetSourceFilter() {
      this.visibleOptionsSource = null;
      this.filterValueSource = null;
      this.sourceFilterViewChild && (this.sourceFilterViewChild.nativeElement.value = '');
    }
    resetTargetFilter() {
      this.visibleOptionsTarget = null;
      this.filterValueTarget = null;
      this.targetFilterViewChild && (this.targetFilterViewChild.nativeElement.value = '');
    }
    resetFilter() {
      this.resetSourceFilter();
      this.resetTargetFilter();
    }
    /*onItemKeydown(event: KeyboardEvent, item: any, selectedItems: any[], callback: EventEmitter<any>) {
        let listItem = <HTMLLIElement>event.currentTarget;
         switch (event.which) {
            //down
            case 40:
                var nextItem = this.findNextItem(listItem);
                if (nextItem) {
                    nextItem.focus();
                }
                 event.preventDefault();
                break;
             //up
            case 38:
                var prevItem = this.findPrevItem(listItem);
                if (prevItem) {
                    prevItem.focus();
                }
                 event.preventDefault();
                break;
             //enter
            case 13:
                this.onSpaceKey(event, selectedItems, callback, listType);
                break;
        }
    }*/
    findNextItem(item) {
      let nextItem = item.nextElementSibling;
      if (nextItem) return !DomHandler.hasClass(nextItem, 'p-picklist-item') || DomHandler.isHidden(nextItem) ? this.findNextItem(nextItem) : nextItem;else return null;
    }
    findPrevItem(item) {
      let prevItem = item.previousElementSibling;
      if (prevItem) return !DomHandler.hasClass(prevItem, 'p-picklist-item') || DomHandler.isHidden(prevItem) ? this.findPrevItem(prevItem) : prevItem;else return null;
    }
    initMedia() {
      if (isPlatformBrowser(this.platformId)) {
        this.media = this.window.matchMedia(`(max-width: ${this.breakpoint})`);
        this.viewChanged = this.media.matches;
        this.bindMediaChangeListener();
      }
    }
    destroyMedia() {
      this.unbindMediaChangeListener();
    }
    bindMediaChangeListener() {
      if (this.media && !this.mediaChangeListener) {
        this.mediaChangeListener = this.renderer.listen(this.media, 'change', event => {
          this.viewChanged = event.matches;
          this.cd.markForCheck();
        });
      }
    }
    unbindMediaChangeListener() {
      if (this.mediaChangeListener) {
        this.mediaChangeListener();
        this.mediaChangeListener = null;
      }
    }
    createStyle() {
      if (isPlatformBrowser(this.platformId)) {
        if (!this.styleElement) {
          this.renderer.setAttribute(this.el.nativeElement.children[0], this.id, '');
          this.styleElement = this.renderer.createElement('style');
          this.renderer.setAttribute(this.styleElement, 'type', 'text/css');
          DomHandler.setAttribute(this.styleElement, 'nonce', this.config?.csp()?.nonce);
          this.renderer.appendChild(this.document.head, this.styleElement);
          let innerHTML = `
                @media screen and (max-width: ${this.breakpoint}) {
                    .p-picklist[${this.id}] {
                        flex-direction: column;
                    }

                    .p-picklist[${this.id}] .p-picklist-buttons {
                        padding: var(--content-padding);
                        flex-direction: row;
                    }

                    .p-picklist[${this.id}] .p-picklist-buttons .p-button {
                        margin-right: var(--inline-spacing);
                        margin-bottom: 0;
                    }

                    .p-picklist[${this.id}] .p-picklist-buttons .p-button:last-child {
                        margin-right: 0;
                    }
                }`;
          this.renderer.setProperty(this.styleElement, 'innerHTML', innerHTML);
        }
      }
    }
    sourceMoveDisabled() {
      if (this.disabled || !this.selectedItemsSource.length) {
        return true;
      }
    }
    targetMoveDisabled() {
      if (this.disabled || !this.selectedItemsTarget.length) {
        return true;
      }
    }
    moveRightDisabled() {
      return this.disabled || ObjectUtils.isEmpty(this.selectedItemsSource);
    }
    moveLeftDisabled() {
      return this.disabled || ObjectUtils.isEmpty(this.selectedItemsTarget);
    }
    moveAllRightDisabled() {
      return this.disabled || ObjectUtils.isEmpty(this.source);
    }
    moveAllLeftDisabled() {
      return this.disabled || ObjectUtils.isEmpty(this.target);
    }
    destroyStyle() {
      if (this.styleElement) {
        this.renderer.removeChild(this.document.head, this.styleElement);
        this.styleElement = null;
        ``;
      }
    }
    ngOnDestroy() {
      this.destroyStyle();
      this.destroyMedia();
    }
    static ɵfac = function PickList_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PickList)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.FilterService), i0.ɵɵdirectiveInject(i1.PrimeNGConfig), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PickList,
      selectors: [["p-pickList"]],
      contentQueries: function PickList_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      viewQuery: function PickList_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
          i0.ɵɵviewQuery(_c1, 5);
          i0.ɵɵviewQuery(_c2, 5);
          i0.ɵɵviewQuery(_c3, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listViewSourceChild = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listViewTargetChild = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sourceFilterViewChild = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.targetFilterViewChild = _t.first);
        }
      },
      hostAttrs: [1, "p-element"],
      inputs: {
        source: "source",
        target: "target",
        sourceHeader: "sourceHeader",
        tabindex: [2, "tabindex", "tabindex", numberAttribute],
        rightButtonAriaLabel: "rightButtonAriaLabel",
        leftButtonAriaLabel: "leftButtonAriaLabel",
        allRightButtonAriaLabel: "allRightButtonAriaLabel",
        allLeftButtonAriaLabel: "allLeftButtonAriaLabel",
        upButtonAriaLabel: "upButtonAriaLabel",
        downButtonAriaLabel: "downButtonAriaLabel",
        topButtonAriaLabel: "topButtonAriaLabel",
        bottomButtonAriaLabel: "bottomButtonAriaLabel",
        targetHeader: "targetHeader",
        responsive: [2, "responsive", "responsive", booleanAttribute],
        filterBy: "filterBy",
        filterLocale: "filterLocale",
        trackBy: "trackBy",
        sourceTrackBy: "sourceTrackBy",
        targetTrackBy: "targetTrackBy",
        showSourceFilter: [2, "showSourceFilter", "showSourceFilter", booleanAttribute],
        showTargetFilter: [2, "showTargetFilter", "showTargetFilter", booleanAttribute],
        metaKeySelection: [2, "metaKeySelection", "metaKeySelection", booleanAttribute],
        dragdrop: [2, "dragdrop", "dragdrop", booleanAttribute],
        style: "style",
        styleClass: "styleClass",
        sourceStyle: "sourceStyle",
        targetStyle: "targetStyle",
        showSourceControls: [2, "showSourceControls", "showSourceControls", booleanAttribute],
        showTargetControls: [2, "showTargetControls", "showTargetControls", booleanAttribute],
        sourceFilterPlaceholder: "sourceFilterPlaceholder",
        targetFilterPlaceholder: "targetFilterPlaceholder",
        disabled: [2, "disabled", "disabled", booleanAttribute],
        ariaSourceFilterLabel: "ariaSourceFilterLabel",
        ariaTargetFilterLabel: "ariaTargetFilterLabel",
        filterMatchMode: "filterMatchMode",
        stripedRows: [2, "stripedRows", "stripedRows", booleanAttribute],
        keepSelection: [2, "keepSelection", "keepSelection", booleanAttribute],
        breakpoint: "breakpoint",
        selectionDescription: "selectionDescription",
        movingHint: "movingHint"
      },
      outputs: {
        onMoveToSource: "onMoveToSource",
        onMoveAllToSource: "onMoveAllToSource",
        onMoveAllToTarget: "onMoveAllToTarget",
        onMoveToTarget: "onMoveToTarget",
        onSourceReorder: "onSourceReorder",
        onTargetReorder: "onTargetReorder",
        onSourceSelect: "onSourceSelect",
        onTargetSelect: "onTargetSelect",
        onSourceFilter: "onSourceFilter",
        onTargetFilter: "onTargetFilter",
        onFocus: "onFocus",
        onBlur: "onBlur"
      },
      standalone: false,
      features: [i0.ɵɵInputTransformsFeature],
      decls: 27,
      vars: 70,
      consts: [["sourcelist", ""], ["targetlist", ""], ["builtInSourceElement", ""], ["sourceFilter", ""], ["builtInTargetElement", ""], ["targetFilter", ""], ["cdkDropListGroup", "", 3, "ngStyle", "ngClass"], ["class", "p-picklist-buttons p-picklist-source-controls", 4, "ngIf"], ["id", "movingHint", "aria-live", "polite", 1, "visibilityOnlyForScreenreader"], [1, "p-picklist-list-wrapper", "p-picklist-source-wrapper"], ["class", "p-picklist-header", 3, "id", 4, "ngIf"], ["class", "p-picklist-filter-container", 4, "ngIf"], ["cdkDropList", "", "role", "listbox", "aria-multiselectable", "multiple", 1, "p-picklist-list", "p-picklist-source", 3, "focus", "blur", "cdkDropListDropped", "id", "cdkDropListData", "ngStyle"], ["ngFor", "", 3, "ngForOf", "ngForTrackBy"], [4, "ngIf"], [1, "p-picklist-buttons", "p-picklist-transfer-buttons"], ["type", "button", "autofocus", "", "icon", "pi pi-angle-right", "pButton", "", "pRipple", "", 1, "p-button-icon-only", 3, "click", "disabled"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["type", "button", "autofocus", "", "icon", "pi pi-angle-double-right", "pButton", "", "pRipple", "", 1, "p-button-icon-only", 3, "click", "disabled"], ["type", "button", "autofocus", "", "icon", "pi pi-angle-left", "pButton", "", "pRipple", "", 1, "p-button-icon-only", 3, "click", "disabled"], ["type", "button", "autofocus", "", "icon", "pi pi-angle-double-left", "pButton", "", "pRipple", "", 1, "p-button-icon-only", 3, "click", "disabled"], [1, "p-picklist-list-wrapper", "p-picklist-target-wrapper"], ["cdkDropList", "", "role", "listbox", "aria-multiselectable", "multiple", 1, "p-picklist-list", "p-picklist-target", 3, "focus", "blur", "cdkDropListDropped", "id", "cdkDropListData", "ngStyle"], ["class", "p-picklist-buttons p-picklist-target-controls", 4, "ngIf"], [1, "p-picklist-buttons", "p-picklist-source-controls"], ["type", "button", "icon", "pi pi-angle-up", "pButton", "", "pRipple", "", 1, "p-button-icon-only", 3, "click", "disabled"], ["type", "button", "icon", "pi pi-angle-double-up", "pButton", "", "pRipple", "", 1, "p-button-icon-only", 3, "click", "disabled"], ["type", "button", "icon", "pi pi-angle-down", "pButton", "", "pRipple", "", 1, "p-button-icon-only", 3, "click", "disabled"], ["type", "button", "icon", "pi pi-angle-double-down", "pButton", "", "pRipple", "", 1, "p-button-icon-only", 3, "click", "disabled"], [1, "p-picklist-header", 3, "id"], ["class", "p-picklist-title", 4, "ngIf"], [4, "ngTemplateOutlet"], [1, "p-picklist-title"], [1, "p-picklist-filter-container"], [4, "ngIf", "ngIfElse"], [1, "p-picklist-filter"], ["type", "text", "role", "textbox", 1, "p-picklist-filter-input", "p-inputtext", "p-component", 3, "keyup", "disabled"], [3, "styleClass", 4, "ngIf"], ["class", "p-picklist-filter-icon", 4, "ngIf"], [3, "styleClass"], [1, "p-picklist-filter-icon"], ["pRipple", "", "cdkDrag", "", "tabindex", "0", "role", "option", 3, "ngClass", "id", "cdkDragData", "cdkDragDisabled", "click", "dblclick", "mousedown", "touchend", "keydown", 4, "ngIf"], ["pRipple", "", "cdkDrag", "", "tabindex", "-1", "role", "option", 3, "ngClass", "id", "cdkDragData", "cdkDragDisabled", "click", "dblclick", "touchend", "keydown", 4, "ngIf"], ["pRipple", "", "cdkDrag", "", "tabindex", "0", "role", "option", 3, "click", "dblclick", "mousedown", "touchend", "keydown", "ngClass", "id", "cdkDragData", "cdkDragDisabled"], ["pRipple", "", "cdkDrag", "", "tabindex", "-1", "role", "option", 3, "click", "dblclick", "touchend", "keydown", "ngClass", "id", "cdkDragData", "cdkDragDisabled"], ["class", "p-picklist-empty-message", 4, "ngIf"], [1, "p-picklist-empty-message"], ["pRipple", "", "cdkDrag", "", "tabindex", "0", "role", "option", 3, "ngClass", "id", "cdkDragData", "cdkDragDisabled", "click", "keydown", "mousedown", "dblclick", "touchend", 4, "ngIf"], ["pRipple", "", "cdkDrag", "", "tabindex", "0", "role", "option", 3, "click", "keydown", "mousedown", "dblclick", "touchend", "ngClass", "id", "cdkDragData", "cdkDragDisabled"], [1, "p-picklist-buttons", "p-picklist-target-controls"]],
      template: function PickList_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 6);
          i0.ɵɵtemplate(1, PickList_div_1_Template, 5, 14, "div", 7);
          i0.ɵɵelement(2, "div", 8);
          i0.ɵɵelementStart(3, "div", 9);
          i0.ɵɵtemplate(4, PickList_div_4_Template, 3, 5, "div", 10)(5, PickList_div_5_Template, 4, 3, "div", 11);
          i0.ɵɵelementStart(6, "ul", 12, 0);
          i0.ɵɵlistener("focus", function PickList_Template_ul_focus_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onListFocus($event, ctx.SOURCE_LIST));
          })("blur", function PickList_Template_ul_blur_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onListBlur($event, ctx.SOURCE_LIST));
          })("cdkDropListDropped", function PickList_Template_ul_cdkDropListDropped_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onDrop($event, ctx.SOURCE_LIST));
          });
          i0.ɵɵtemplate(8, PickList_ng_template_8_Template, 2, 2, "ng-template", 13)(9, PickList_ng_container_9_Template, 3, 2, "ng-container", 14);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(10, "div", 15)(11, "button", 16);
          i0.ɵɵlistener("click", function PickList_Template_button_click_11_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.moveRight());
          });
          i0.ɵɵtemplate(12, PickList_12_Template, 1, 0, null, 17);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(13, "button", 18);
          i0.ɵɵlistener("click", function PickList_Template_button_click_13_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.moveAllRight());
          });
          i0.ɵɵtemplate(14, PickList_14_Template, 1, 0, null, 17);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(15, "button", 19);
          i0.ɵɵlistener("click", function PickList_Template_button_click_15_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.moveLeft());
          });
          i0.ɵɵtemplate(16, PickList_16_Template, 1, 0, null, 17);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(17, "button", 20);
          i0.ɵɵlistener("click", function PickList_Template_button_click_17_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.moveAllLeft());
          });
          i0.ɵɵtemplate(18, PickList_18_Template, 1, 0, null, 17);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(19, "div", 21);
          i0.ɵɵtemplate(20, PickList_div_20_Template, 3, 5, "div", 10)(21, PickList_div_21_Template, 4, 3, "div", 11);
          i0.ɵɵelementStart(22, "ul", 22, 1);
          i0.ɵɵlistener("focus", function PickList_Template_ul_focus_22_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onListFocus($event, ctx.TARGET_LIST));
          })("blur", function PickList_Template_ul_blur_22_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onListBlur($event, ctx.TARGET_LIST));
          })("cdkDropListDropped", function PickList_Template_ul_cdkDropListDropped_22_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onDrop($event, ctx.TARGET_LIST));
          });
          i0.ɵɵtemplate(24, PickList_ng_template_24_Template, 2, 2, "ng-template", 13)(25, PickList_ng_container_25_Template, 3, 2, "ng-container", 14);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(26, PickList_div_26_Template, 5, 14, "div", 23);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.styleClass);
          i0.ɵɵproperty("ngStyle", ctx.style)("ngClass", i0.ɵɵpureFunction1(60, _c4, ctx.stripedRows));
          i0.ɵɵattribute("data-pc-name", "picklist")("data-pc-section", "root");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showSourceControls);
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("data-pc-section", "sourceWrapper")("data-pc-group-section", "listWrapper");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.sourceHeader || ctx.sourceHeaderTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.filterBy && ctx.showSourceFilter !== false);
          i0.ɵɵadvance();
          i0.ɵɵproperty("id", ctx.idSource + "_list")("cdkDropListData", ctx.source)("ngStyle", ctx.sourceStyle);
          i0.ɵɵattribute("aria-activedescendant", ctx.focused["sourceList"] ? ctx.focusedOptionId : undefined)("data-pc-section", "sourceList")("data-pc-group-section", "list")("aria-label", ctx.sourceHeader)("aria-description", ctx.selectionDescription);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.source)("ngForTrackBy", ctx.sourceTrackBy || ctx.trackBy);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isEmpty(ctx.SOURCE_LIST) && (ctx.emptyMessageSourceTemplate || ctx.emptyFilterMessageSourceTemplate));
          i0.ɵɵadvance();
          i0.ɵɵattribute("data-pc-section", "buttons")("data-pc-group-section", "controls");
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.moveRightDisabled());
          i0.ɵɵattribute("aria-label", ctx.rightButtonAriaLabel)("title", ctx.rightButtonAriaLabel);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", ctx.moveToTargetIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(62, _c5, ctx.viewChanged));
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.moveAllRightDisabled());
          i0.ɵɵattribute("aria-label", ctx.allRightButtonAriaLabel)("title", ctx.allRightButtonAriaLabel);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", ctx.moveAllToTargetIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(64, _c5, ctx.viewChanged));
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.moveLeftDisabled());
          i0.ɵɵattribute("aria-label", ctx.leftButtonAriaLabel)("title", ctx.leftButtonAriaLabel);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", ctx.moveToSourceIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(66, _c5, ctx.viewChanged));
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.moveAllLeftDisabled());
          i0.ɵɵattribute("aria-label", ctx.allLeftButtonAriaLabel)("title", ctx.allLeftButtonAriaLabel);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", ctx.moveAllToSourceIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(68, _c5, ctx.viewChanged));
          i0.ɵɵadvance();
          i0.ɵɵattribute("data-pc-section", "targetWrapper")("data-pc-group-section", "listwrapper");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.targetHeader || ctx.targetHeaderTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.filterBy && ctx.showTargetFilter !== false);
          i0.ɵɵadvance();
          i0.ɵɵproperty("id", ctx.idTarget + "_list")("cdkDropListData", ctx.target)("ngStyle", ctx.targetStyle);
          i0.ɵɵattribute("aria-activedescendant", ctx.focused["targetList"] ? ctx.focusedOptionId : undefined)("tabindex", ctx.target && ctx.target.length > 0 ? ctx.tabindex : -1)("data-pc-section", "targetList")("data-pc-group-section", "list")("aria-label", ctx.targetHeader);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.target)("ngForTrackBy", ctx.targetTrackBy || ctx.trackBy);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isEmpty(ctx.TARGET_LIST) && (ctx.emptyMessageTargetTemplate || ctx.emptyFilterMessageTargetTemplate));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showTargetControls);
        }
      },
      dependencies: () => [i2.NgClass, i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2.NgStyle, i3.ButtonDirective, i4.Ripple, i5.CdkDropList, i5.CdkDropListGroup, i5.CdkDrag, SearchIcon],
      styles: [".p-picklist{display:flex}.p-picklist-buttons{display:flex;flex-direction:column;justify-content:center}.p-picklist-list-wrapper{flex:1 1 50%}.p-picklist-list{list-style-type:none;margin:0;padding:0;overflow:auto;min-height:12rem}.p-picklist-item{display:block;cursor:pointer;overflow:hidden;position:relative}.p-picklist-item:not(.cdk-drag-disabled){cursor:move}.p-picklist-item.cdk-drag-placeholder{opacity:0}.p-picklist-item.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.p-picklist-filter{position:relative}.p-picklist-filter-icon{position:absolute;top:50%;margin-top:-.5rem}.p-picklist-filter-input{width:100%}.p-picklist-list.cdk-drop-list-dragging .p-picklist-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return PickList;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DragConfig = {
  zIndex: 1200
};
let PickListModule = /*#__PURE__*/(() => {
  class PickListModule {
    static ɵfac = function PickListModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PickListModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PickListModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: CDK_DRAG_CONFIG,
        useValue: DragConfig
      }],
      imports: [CommonModule, ButtonModule, SharedModule, RippleModule, DragDropModule, AngleDoubleDownIcon, AngleDoubleLeftIcon, AngleDoubleRightIcon, AngleDoubleUpIcon, AngleDownIcon, AngleLeftIcon, AngleRightIcon, AngleUpIcon, SearchIcon, HomeIcon, SharedModule, DragDropModule]
    });
  }
  return PickListModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { PickList, PickListModule };
